import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Logo from './partials/Logo';
import coldsatsLogo from './../../assets/images/coldsats/coldsats-orange-bitcoin-logo-white@0.25x.png'
import Image from '../elements/Image'
import "../../assets/scss/style.scss";

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  showLogout: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool
}

const defaultProps = {
  navPosition: '',
  hideNav: false,
  hideSignin: false,
  showLogout: false,
  bottomOuterDivider: false,
  bottomDivider: false
}

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  showLogout,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {

  const [isActive, setIsactive] = useState(false);

  const nav = useRef(null);
  const hamburger = useRef(null);

  useEffect(() => {
    isActive && openMenu();
    document.addEventListener('keydown', keyPress);
    document.addEventListener('click', clickOutside);
    return () => {
      document.removeEventListener('keydown', keyPress);
      document.addEventListener('click', clickOutside);
      closeMenu();
    };
  });  

  const openMenu = () => {
    document.body.classList.add('off-nav-is-active');
    nav.current.style.maxHeight = nav.current.scrollHeight + 'px';
    setIsactive(true);
  }

  const closeMenu = () => {
    document.body.classList.remove('off-nav-is-active');
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  }

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  }

  const clickOutside = (e) => {
    if (!nav.current) return
    if (!isActive || nav.current.contains(e.target) || e.target === hamburger.current) return;
    closeMenu();
  }  

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  return (
    <header
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-header-inner',
            bottomDivider && 'has-bottom-divider'
          )}>
          <Logo />
          {!hideNav &&
            <>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
                ref={nav}
                className={
                  classNames(
                    'header-nav',
                    isActive && 'is-active'
                  )}>
                <div className="header-nav-inner">
                  <ul className={
                    classNames(
                      'list-reset text-xs',
                      navPosition && `header-nav-left`
                    )}>
                    <li>
                      <a  href="https://blog.xsats.com" target = "_blank" rel = "noopener noreferrer">Blog</a>
                    </li>
                    <li>
                      <a  href="https://xsats.com/faq" target = "_blank" rel = "noopener noreferrer" onClick={closeMenu}>FAQ</a>
                    </li>
                    {/* {showLogout ? <li>
                      <Link to="/home" onClick={closeMenu}>Home</Link>
                    </li> : null} */}
                  </ul>
                  <ul className="header-nav-right">
                      <a  href="https://xsats.com/cold" target = "_blank" rel = "noopener noreferrer" onClick={closeMenu}>
                        <Image
                          className="has-shadow"
                          src={coldsatsLogo}
                          alt="coldsats"
                          style={{color: "#FFF"}}
                          color="#FFF"
                          width={120}/>
                      </a>
                  </ul>
                  {/* <ul
                      className="list-reset header-nav-right"
                    >
                      <li>
                        <a className="button button-quaternary button-wide-mobile button-sm"  href="https://xsats.com/app" target = "_blank" rel = "noopener noreferrer" onClick={closeMenu}>Download App</a>
                      </li>
                    </ul> */}
                  {!hideSignin &&
                    <ul
                      className="list-reset header-nav-right"
                    >
                      <li>
                        <Link to="/start" className="button button-quaternary button-wide-mobile button-sm" onClick={closeMenu}>Stack Again</Link>
                      </li>                      
                      <li>
                        <Link to="/x/" className="button button-secondary button-wide-mobile button-sm" onClick={closeMenu}>Start Saving</Link>
                      </li>
                    </ul>
                  }
                  {showLogout &&
                    <ul className="list-reset header-nav-right">
                      <li>
                        <Link to="/exit" className="button button-secondary button-wide-mobile button-sm" onClick={closeMenu}>Exit Order</Link>
                      </li>
                    </ul>
                  }
                </div>
              </nav>
            </>}
        </div>
      </div>
    </header>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;